import axios from "axios";
import { baseURL } from "./Api";
import { getToken, clearSession } from "../session";

export const Axios = axios.create({
  baseURL: baseURL,
});

Axios.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${getToken()}`;
  return config;
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearSession();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);
